var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.677,
    height: 24.677,
    viewBox: "0 0 24.677 24.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(-38.615 -411.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(38.615 411.116)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 12.339,
    cy: 12.339,
    r: 12.339,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, -3199.777, 2627.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M3890.353-489.011a2.15,2.15,0,0,1,.34-.789,1.685,1.685,0,0,1,1.372-.694c.737-.006,1.473,0,2.21,0a.609.609,0,0,0,.22-.043q2.263-.915,4.523-1.838a.333.333,0,0,0,.16-.157,1.377,1.377,0,0,1,1.494-.8,1.349,1.349,0,0,1,1.124,1.3c.012.47,0,.941,0,1.412,0,2.006-.008,4.012,0,6.018a1.4,1.4,0,0,1-.911,1.377,1.375,1.375,0,0,1-1.664-.638.332.332,0,0,0-.142-.143q-2.016-.825-4.036-1.64c-.03-.012-.061-.02-.111-.036v.164c0,.675,0,1.35,0,2.025a1.3,1.3,0,0,1-1.068,1.311,1.28,1.28,0,0,1-1.522-1.151c-.033-.792-.013-1.587-.017-2.381v-.189c-.148-.007-.281-.006-.412-.02a1.712,1.712,0,0,1-1.545-1.427.392.392,0,0,0-.024-.066Zm8.7-2.385c-.056.019-.1.031-.136.047q-1.939.786-3.878,1.57c-.09.036-.1.089-.1.173,0,.932,0,1.863,0,2.795a.178.178,0,0,0,.135.194q1.512.608,3.021,1.223l.962.387Zm1.831,3.139q0-1.8,0-3.592c0-.057,0-.114,0-.171a.443.443,0,0,0-.425-.419.443.443,0,0,0-.471.384,1.258,1.258,0,0,0-.009.185q0,3.621,0,7.242a1.226,1.226,0,0,0,.011.2.448.448,0,0,0,.538.361.455.455,0,0,0,.357-.5Q3900.889-486.41,3900.888-488.257Zm-6.871,1.428v-2.754c-.648,0-1.285,0-1.922,0a.8.8,0,0,0-.829.826c0,.352,0,.7,0,1.055a.815.815,0,0,0,.881.879q.863,0,1.725,0C3893.918-486.822,3893.965-486.826,3894.017-486.828Zm0,.929h-.763c0,.04-.01.077-.01.114q0,1.132,0,2.264a.8.8,0,0,0,.01.128.377.377,0,0,0,.377.321.394.394,0,0,0,.393-.443q0-1.132,0-2.264C3894.029-485.818,3894.024-485.855,3894.021-485.9Z",
    transform: "translate(0 0)",
    fill: "#8b65ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M4208.32-319.869a.449.449,0,0,1-.646.407c-.357-.186-.7-.393-1.048-.6a.44.44,0,0,1-.141-.591.44.44,0,0,1,.588-.19c.355.191.7.4,1.049.6A.437.437,0,0,1,4208.32-319.869Z",
    transform: "translate(-304.028 -165.889)",
    fill: "#8b65ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M4221-371.29c.19,0,.38,0,.569,0a.451.451,0,0,1,.446.429.442.442,0,0,1-.414.474c-.4.016-.807.015-1.209,0a.447.447,0,0,1-.419-.471.452.452,0,0,1,.458-.433c.19-.005.379,0,.569,0Z",
    transform: "translate(-317.055 -117.413)",
    fill: "#8b65ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M4206.94-435.25a.468.468,0,0,1-.469-.311.433.433,0,0,1,.164-.505c.351-.215.708-.423,1.072-.617a.436.436,0,0,1,.568.182.436.436,0,0,1-.122.6c-.35.218-.711.417-1.07.62A.456.456,0,0,1,4206.94-435.25Z",
    transform: "translate(-304.048 -54.471)",
    fill: "#8b65ef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/AnnouncementIcon.a9ab855d7843e454e04b95a8273c6132.svg";
export { ForwardRef as ReactComponent };